import React, { Component, Fragment } from 'react';
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption } from 'reactstrap';
import { MessageBars } from '../Outils/MessageBars';

import { SpinnerChargement } from '../Loader/SpinnerChargement';

import { Immocom } from '../../specifique/immocom';

import './CarouselOperation.css';
import perspectiveDefaut from '../../images/PerspectiveDefaut.jpg';

import { Data } from '../../data/Data';
import { DataOperation } from '../../data/DataOperation';
import { Stack, StackItem } from 'office-ui-fabric-react';

const operationParDefaut = {
    key: 'perspectiveParDefaut',
    src: perspectiveDefaut,
    header: 'EIFFIMMO',
    altText: 'EIFFAGE IMMOBILIER - EIFFIMMO',
    caption: 'EIFFAGE IMMOBILIER'
}

export class CarouselProgramme extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listOperations: [],
            listOperationsCarousel: this.props.avecImageParDefaut ? [operationParDefaut] : [],
            index: 0,
            activeIndex: 0,
            animating: false,
            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            hideMessageBarError: true,
            errorMessage: '',
            hideMessageBarWarning: true,
            warningMessage: ''
        };
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des opérations"
        });

        let chargementFicheCarouselProgramme = Data._chargementFicheCarouselProgramme();

        chargementFicheCarouselProgramme
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    this.setState({
                        listOperations: objetData,
                        listOperationsCarousel: [operationParDefaut],

                        index: 0,
                        activeIndex: 0,

                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',

                        hideMessageBarWarning: true,
                        warningMessage: '',
                        hideMessageBarError: true,
                        errorMessage: ''
                    });

                    this._chargementPerspectiveOperation(objetData[0]);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _chargementPerspectiveOperation(operation) {
        if (operation !== undefined) {

            let _chargementFicheOperation_PhotoTailleReelle = DataOperation._chargementFicheOperation_PhotoTailleReelle(operation.rowGUID);

            _chargementFicheOperation_PhotoTailleReelle
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;
                        let listOperationsCarouselTrav = [...this.state.listOperationsCarousel];

                        const carouselItem = {
                            key: operation.rowGUID,
                            src: `data:image/png;base64,${objetData.fileData}`,
                            header: operation.nomCommercial,
                            altText: operation.nomCommercial,
                            caption: operation.ville + ' (' + operation.cp + ')'
                        };

                        if (listOperationsCarouselTrav.length === 1 && listOperationsCarouselTrav[0].key === "perspectiveParDefaut")
                            listOperationsCarouselTrav = [carouselItem]; // Remplacer la diapo par défaut au chargement de la première image
                        else {
                            const diapositiveExisteDeja = listOperationsCarouselTrav.some(diapositive => diapositive.key === carouselItem.key);
                            if (!diapositiveExisteDeja)
                                listOperationsCarouselTrav.push(carouselItem);
                        }

                        this.setState({
                            listOperationsCarousel: listOperationsCarouselTrav,
                            index: this.state.index + 1,

                            enCoursDeTraitement: false,
                            messageEnCoursTraitement: '',

                            hideMessageBarWarning: true,
                            warningMessage: '',
                            hideMessageBarError: true,
                            errorMessage: ''
                        });
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    next = () => {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === this.state.listOperationsCarousel.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous = () => {
        if (this.state.animating) return;
        const prevIndex = this.state.activeIndex === 0 ? this.state.listOperationsCarousel.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: prevIndex });
    }

    goToIndex = (newIndex) => {
        if (this.state.animating) return;
        this.setState({ activeIndex: newIndex });
    }

    componentDidMount() {
        if (!!this.props.idProgramme)
            this._chargementDonnees();
    }

    componentDidUpdate(prevProps) {
        const { idProgramme } = this.props;
        if (!!idProgramme && idProgramme !== prevProps.idProgramme) {
            this._chargementDonnees();
        }
    }

    render() {
        let slides = [];

        this.state.listOperationsCarousel.map(operation => {
            slides.push(
                <CarouselItem key={`${operation.altText}_${operation.key}`} className={"carousel-item-programme " + this.props.className}>
                    {operation.key === 'perspectiveParDefaut' ? <img src={operation.src} alt={operation.altText} className="imgCarousel" /> :
                        <img
                            src={operation.src}
                            alt={operation.altText}
                            className="imgCarousel"
                            onLoad={e => this._chargementPerspectiveOperation(this.state.listOperations[this.state.index])}
                            onError={e => this._chargementPerspectiveOperation(this.state.listOperations[this.state.index])} // Si erreur, on charge quand même la photo suivante
                        />
                    }
                    {this.props.avecLegende ? <CarouselCaption captionText={operation.caption} captionHeader={operation.header} className="customCaption" /> : null}
                </CarouselItem>
            );
        });

        return (this.state.enCoursDeTraitement ? <SpinnerChargement label={this.state.messageEnCoursTraitement} className="loaderCarousel" /> :
            <Stack verticalFill>
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <StackItem grow styles={{ root: { maxHeight: "100%" } }}>
                    {this.state.listOperationsCarousel.length > 0 ?
                        <Carousel activeIndex={this.state.activeIndex} next={this.next} previous={this.previous} className="carousel-programme">
                            <CarouselIndicators items={this.state.listOperationsCarousel} activeIndex={this.state.activeIndex} onClickHandler={this.goToIndex} />
                            {slides}
                            <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
                            <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
                        </Carousel>
                        : <div>Aucune image disponible</div>
                    }
                </StackItem>
            </Stack>
        );
    }
}
